/**
 * Per-unit equipment rates for VALUE DISPLAY (dashboard, kanban, review, the
 * live ticket totals). These MUST stay in sync with the backend billing
 * fallbacks in `backend/src/services/qbo.js` (TRUCK_UNIT_RATE,
 * DEFAULT_RENTAL_UNIT_RATE) — the value shown in the app and the amount the
 * invoice ships are reconciled through these constants. The real invoice may
 * use the live QBO catalog rate for rentals (resolved async at push time); for
 * synchronous display we fall back to DEFAULT_RENTAL_RATE.
 */
export const EQUIPMENT_TRUCK_UNIT_RATE = 25;
export const EQUIPMENT_DEFAULT_RENTAL_RATE = 350;
export function isTruckEquipmentType(type) {
    return String(type || '').trim().toLowerCase() === 'truck';
}
/** Billable units for an equipment row: quantity × (hours, or 1 when blank). */
export function getEquipmentLineUnits(entry) {
    const qty = Number(entry.quantity ?? 1) || 0;
    const hrs = entry.hours == null ? 1 : Number(entry.hours) || 0;
    return qty * hrs;
}
/**
 * Per-unit rate for an equipment row, for value display. A manager's explicit
 * unit_price_snapshot (including a deliberate 0) wins; otherwise trucks bill the
 * flat truck rate, rentals the default rental rate, and company-owned equipment
 * (is_rental === false) $0 until a manager prices it.
 */
export function getEquipmentLineUnitRate(entry) {
    if (entry.unit_price_snapshot != null)
        return Number(entry.unit_price_snapshot) || 0;
    if (isTruckEquipmentType(entry.equipment_type))
        return EQUIPMENT_TRUCK_UNIT_RATE;
    const isRental = entry.is_rental !== false; // default rental when the flag is absent
    return isRental ? EQUIPMENT_DEFAULT_RENTAL_RATE : 0;
}
/** Value contribution of a single equipment row. */
export function getEquipmentLineValue(entry) {
    return getEquipmentLineUnits(entry) * getEquipmentLineUnitRate(entry);
}
/** Total equipment value across rows (skips soft-deleted rows). */
export function sumEquipmentValue(equipment) {
    return (equipment || [])
        .filter((e) => !e.deleted_at)
        .reduce((sum, e) => sum + getEquipmentLineValue(e), 0);
}
//# sourceMappingURL=equipment.js.map